<template>
  <div id="nav">
    <b-navbar toggleable="lg">
      <b-navbar-brand to="/" id="logo-link">
        <div
          class="logo-container"
        >
          <img src="images/logo.svg" class="mr-4" />
          <span>PDF Download Center</span>
        </div>
      </b-navbar-brand>
      
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item href="/instructions.html"><span class="text-orange">More Information / Instructions</span></b-nav-item>
        </b-navbar-nav>

      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'Header',
}
</script>